/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { tokens } from '@neo4j-ndl/base';

import { type PolymorphicCommonProps } from '../../_common/types';

type ChatTitleProps = {
  children?: React.ReactNode;
};

export const ChatTitle = ({
  children,
  as,
  ref,
  style,
  className,
  htmlAttributes,
  ...restProps
}: PolymorphicCommonProps<'span', ChatTitleProps>) => {
  const Component = as || 'span';

  return (
    <Component
      ref={ref}
      style={{
        backgroundClip: 'text',
        backgroundImage: `linear-gradient(to right, var(--theme-color-neutral-text-default), var(--theme-color-neutral-text-weaker))`,
        color: 'transparent',
        fontFamily: tokens.typography.display.fontFamily,
        fontSize: '1.5rem', // same as title-2
        fontWeight: tokens.weight.medium, // same as display
        letterSpacing: '0.016rem', // same as title-2
        lineHeight: 1.3333, // same as title-2
        ...style,
      }}
      className={className}
      {...htmlAttributes}
      {...restProps}
    >
      {children}
    </Component>
  );
};
